import React from 'react';
import {
  Dialog, DialogContent, DialogTitle,
  RadioGroup, FormControlLabel, Radio,
  Box, IconButton,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';
import TripRequestTable from './table-trip-request';
import TripMatchesTable from './table-trip-matches';
import SoldTripsTable from './table-sold-trips';
import { TravelHistoryModalViewProps, SelectedTab } from './types';

const TravelHistoryModalView = ({
  open,
  selectedTab,
  handleTabChange,
  handleClose,
  tripRequests,
  tripMatches,
  soldTrips,
  reviews,
  isLoading,
}: TravelHistoryModalViewProps) => (
  <Dialog
    open={open}
    onClose={handleClose}
    maxWidth="md"
    fullWidth
  >
    <DialogTitle>Travel History</DialogTitle>
    <IconButton
      aria-label="close"
      onClick={handleClose}
      color="primary"
      sx={{
        position: 'absolute',
        right: 24,
        top: 24,
      }}
    >
      <OutlinedIcons.OutlinedXIcon />
    </IconButton>
    <DialogContent>
      <RadioGroup
        name="travel-history-buttons-group"
        value={selectedTab}
        onChange={(event, value) => handleTabChange(value as SelectedTab)}
        row
        sx={{
          flexDirection: {
            mobile: 'column',
            desktop: 'row',
          },
        }}
      >
        <FormControlLabel value="trip-requests" control={<Radio />} label={`Trip Requests (${tripRequests?.length || 0})`} />
        <FormControlLabel value="matches" control={<Radio />} label={`Matches (${tripMatches?.length || 0})`} />
        <FormControlLabel value="sold-trips" control={<Radio />} label={`Sold Trips (${soldTrips?.length || 0})`} />
      </RadioGroup>

      {isLoading ? (
        <Box sx={{ height: 250 }} />
      ) : (
        <>
          {selectedTab === 'trip-requests' && <TripRequestTable tripRequests={tripRequests} />}
          {selectedTab === 'matches' && <TripMatchesTable tripMatches={tripMatches} />}
          {selectedTab === 'sold-trips' && <SoldTripsTable tripMatches={soldTrips} reviews={reviews} />}
        </>
      )}
    </DialogContent>
  </Dialog>
);

export default TravelHistoryModalView;
